import React from 'react';

export const Phone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="112"
      viewBox="0 0 112 112"
    >
      <g
        id="Ársskýrsla/icon/Appið"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <g
          id="Group"
          stroke="#163E63"
          strokeWidth="2"
          transform="translate(34 18)"
        >
          <path id="Path" d="M44 63.5L0 63.5"></path>
          <path
            id="Path"
            d="M21.5 68.75a.75.75 0 01.75.75h0a.75.75 0 01-.75.75h0a.75.75 0 01-.75-.75h0a.75.75 0 01.75-.75"
          ></path>
          <path id="Path" d="M0 0L44 0 44 76 0 76z"></path>
        </g>
      </g>
    </svg>
  );
};
